import Image from 'components/molecules/Image';
import AfterSchoolLogoImg from './AfterSchoolLogo.png';
import { ImageProps } from 'next/legacy/image';

function AfterSchoolLogo(props: Omit<ImageProps, 'src' | 'alt'>) {
  return (
    <Image width={100} height={100 * (320 / 1145)} {...props} src={AfterSchoolLogoImg} alt="서울런 로고" />
  );
}

export default AfterSchoolLogo;
